import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import {
	EnvironmentConfig,
	ENV_CONFIG
} from "@core/environments/environment-config";
import { RecoveryPassword, ResetPassword } from "@data/schemas/password";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class PasswordService {
	private userRecoveryPasswordData!: RecoveryPassword;

	constructor(
		@Inject(ENV_CONFIG) private config: EnvironmentConfig,
		private http: HttpClient
	) {}

	resetPassword(
		newPassword: Pick<
			ResetPassword,
			"confirmNewPassword" | "newPassword" | "validationCode"
		>
	): Observable<unknown> {
		return this.http.post(
			`${this.config.environment.API}/management/users/${this.userRecoveryPasswordData.idUsuario}/recovery-change-password`,
			newPassword
		);
	}
}
